import { END_POINTS } from "../constants/urls";
import { CommonBody } from "../types/General";
import { USER as User } from "../types/User";
import emptySplitApi from "../utils/rtk";

export  interface CommonResponseType {
  status: number;
  message: string;
  statusCode: number;
  code: number;
}

export const authApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    postLogIn: builder.mutation<CommonResponseType & { data: User }, {}>({
      query: (body) => ({
        url: END_POINTS.login,
        method: "POST",
        body,
      }),
    }),
    getUser: builder.query<CommonResponseType & { data: User }, {}>({
      query: () => ({
        url: END_POINTS.get_user,
        method: "GET",
      }),
    }),
    postLogout: builder.mutation<CommonResponseType, {}>({
      query: () => ({
        url: END_POINTS.logout,
        method: "GET",
      }),
    }),
    forgotPassword: builder.mutation<CommonResponseType, {}>({
      query: (body) => ({
        url: END_POINTS.forgotPassword,
        method: "POST",
        body,
      }),
    }),
    postVerifyOtp: builder.mutation<CommonResponseType & { data: User }, {}>({
      query: (body) => ({
        url: END_POINTS.resetPassword,
        method: "POST",
        body,
      }),
    }),
    resetPassword: builder.mutation<CommonResponseType, {}>({
      query: (body) => ({
        url: END_POINTS.resetPassword,
        method: "POST",
        body,
      }),
    }),
    putUpdateProfile: builder.mutation<CommonResponseType & { data: any }, {}>({
      query: (body) => ({
        url: END_POINTS.updateProfile,
        method: "PUT",
        body,
      }),
    }),
    postChangePassword: builder.mutation<CommonResponseType, {}>({
      query: (body) => ({
        url: END_POINTS.changePassword,
        method: "POST",
        body,
      }),
    }),
  }),
});

export const {
  usePostLogInMutation,
  useForgotPasswordMutation,
  usePostVerifyOtpMutation,
  useResetPasswordMutation,
  useLazyGetUserQuery,
  usePutUpdateProfileMutation,
  useGetUserQuery,
  usePostLogoutMutation,
  usePostChangePasswordMutation,
} = authApi;
